import { Directive, ElementRef, Input, OnChanges, Renderer2 } from "@angular/core";

@Directive({
  selector: "[a11yTitle]",
})
export class A11yTitleDirective implements OnChanges {
  @Input()
  public a11yTitle: string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  public ngOnChanges(): void {
    if (this.a11yTitle) {
      this.renderer.setAttribute(this.elementRef.nativeElement, "title", this.a11yTitle);
      this.renderer.setAttribute(this.elementRef.nativeElement, "aria-label", this.a11yTitle);
    } else {
      this.renderer.removeAttribute(this.elementRef.nativeElement, "title");
      this.renderer.removeAttribute(this.elementRef.nativeElement, "aria-label");
    }
  }
}
